import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SupplierGuideService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return 'api/sup-gui/find-by-login';
  }

  get(): Observable<any[]> {
    const url = `${this.getUrl()}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`)),
    );
  }


  confirm(object: any): Observable<any> {
    return this.http.post<any>(`api/sup-gui/turn-potential-by-sup`, object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

  getQuestion(): Observable<any[]> {
    const url = `api/questionary/all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`)),
    );
  }

  getPurchase(params): Observable<any> {
    return this.http.get(`api/sup-gui/find-by-supplier-id`,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule')),
    );
  }

  postPurchase(params): Observable<any> {
    return this.http.get(`api/sup-gui/change-ques`,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule')),
    );
  }

  remindPurchase(params): Observable<any> {
    return this.http.get(`api/sup-gui/has-update`,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule')),
    );
  }

  remindSupplier(params): Observable<any> {
    return this.http.get(`api/sup-gui/need-update`,
      {
        headers: httpOptions.headers,
        params: params,
      },
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule')),
    );
  }

}
